<template>
  <v-card>
    <v-card-title class="title card-title-head" @click="expand = !expand">
      <v-col cols="12" md="3">
        <v-icon v-if="!expand">mdi-chevron-right</v-icon>
            <v-icon v-if="expand">mdi-chevron-down</v-icon>
        {{ $i18n.t(label) }}
      </v-col>
      <v-spacer />
      <v-col cols="12" md="2">
        <v-row class="float-right">
          <z-payment-received-create
            color="blue"
            x-small
            :client_id="client_id"
            :clientEntity_id="clientEntity_id"
            :pendingAmount="
              this.billing && this.billing.fare
                ? this.billing.fare.pending
                : null
            "
            :paidAmount="
              this.billing && this.billing.fare
                ? this.billing.fare.amountPaid
                : null
            "
            :itemTotalAmount="
              this.billing && this.billing.fare ? this.billing.fare.total : null
            "
            :date="dateComputed"
            :trip="trip"
            :invoice="invoice"
            :against="2"
            btn
            :hideInvoices="hideInvoices"
            :hideTrips="hideTrips"
            @reload="reload"
            v-if="
              this.billing &&
                this.billing.fare &&
                this.billing.fare.pending &&
                this.billing.fare.pending > 0
            "
          >
            <v-btn color="cyan" x-small>
              {{ $i18n.t("Add Payment Collection") }}
            </v-btn>
          </z-payment-received-create>
        </v-row>
      </v-col>
    </v-card-title>
     <v-expand-transition>
        <v-card-text class="py-0" dense v-if="expand">
          <v-simple-table dense  v-if="collections">
            <thead >
              <tr >
                <th class="primary--text">
                  {{ $i18n.t("Payment Date") }}
                </th>
                <th class="primary--text">{{ $i18n.t("Payment Mode") }}</th>
                <th class="primary--text">{{ $i18n.t("Received Amount") }}</th>
                <th class="primary--text">{{ $i18n.t("Settled") }}</th>
                <th class="primary--text">{{ $i18n.t("Transaction ID") }}</th>
                <th class="text-right primary--text"></th>
                
              </tr>
            </thead>

            <tbody v-if="collections">
              <tr v-for="(collect, index) in collections" :key="index">
                <td>{{ formatDate(collect.date) }}</td>
                <td>{{ collect.mode }}</td>
                <td>{{ collect.totalAmount }}</td>
                <td>{{ collect.tripSettled }}</td>
                <td>{{ collect.transactionID }}</td>
                <td>
                  <!-- <z-confirm-button
                    class="float-right"
                    color="red lighten-1"
                    x-small
                    fab
                    text
                    :loading="expense.e_loading"
                    :message="$i18n.t('Do you want to delete this Expense ?')"
                    @click="deleteExpense(expense)"
                  >
                    <v-icon>mdi-trash-can-outline</v-icon>
                  </z-confirm-button> -->

                  <z-payment-received-create
                    color="blue"
                    style="float: right"
                    x-small
                    :collectEdit_id="collect._id"
                    @reload="reload"
                    btn
                  >
                    <v-btn color="cyan" text fab x-small>
                      <v-icon>mdi-pencil</v-icon>
                    </v-btn>
                  </z-payment-received-create>
                </td>
              </tr>
            </tbody>
          </v-simple-table>
        </v-card-text>
     </v-expand-transition>
    
  </v-card>
</template>

<script>
import { doGet } from "@/store/common/module/apis";
import { Vue, Component } from "vue-property-decorator";

@Component({
  name: "FareCollection",
  components: {},
  props: {
    trip: {
      default: null,
    },
    invoice: {
      default: null,
    },
    client_id: {
      default: null,
    },
    clientEntity_id: {
      default: null,
    },
    date: {
      default: null,
    },
    against: {
      default: null,
    },
    billing: {
      default: {},
    },
    hideTrips: {
      default: null,
    },
    hideInvoices: {
      default: null,
    },
    label: {
      default: "Collection(s)",
    },
  },
})
export default class FareCollection extends Vue {
  dateComputed = null;
  // pendingAmount = null;
  // paidAmount = null;
  // itemTotalAmount = null;
  collections = [];
  expand = false;

  // pendingAmount =
  //   this.billing && this.billing.fare ? this.billing.fare.pending : null;
  // paidAmount =
  //   this.billing && this.billing.fare ? this.billing.fare.amountPaid : null;
  // itemTotalAmount =
  //   this.billing && this.billing.fare ? this.billing.fare.total : null;

  async fetchCollections() {
    if (this.trip && this.trip._id && this.client_id) {
      const collections = await doGet(
        "/api/collectible/trip/" + this.trip._id + "/client/" + this.client_id + "/collections"
      );

      this.collections = collections;

      // const totalAmount =
      //   this.billing && this.billing.fare ? this.billing.fare.total : null;
      // const paidAmount =
      //   this.billing && this.billing.fare ? this.billing.fare.amountPaid : null;
      // let collectedAmount = 0;
      // if (this.collections) {
      //   for (let i = 0; i < this.collections.length; i++) {
      //     if (this.collections[i].tripSettled) {
      //       collectedAmount = collectedAmount + this.collections[i].tripSettled;
      //     }
      //   }
      // }
    }
  }

  async mounted() {
    await this.fetchCollections();
    this.dateComputed = this.$moment(this.trip.startTime * 1000).format(
      "YYYYMMDD"
    );
  }

  formatDate(date) {
    if (date) {
      const dateStr = date.toString();
      return (
        dateStr.substring(6, 8) +
        "-" +
        dateStr.substring(4, 6) +
        "-" +
        dateStr.substring(0, 4)
      );
    } else {
      return "";
    }
  }

  reload(reload) {
    if (reload) {
      this.fetchCollections();
      this.$emit("reload", reload);
    }
  }
}
</script>

<style scoped>
.card-title-head {
  background-color: rgb(211, 235, 240);
  height: 40px;
  padding-top: 0px;
  color: #3b7776;
}
</style>
